module.exports = __webpack_public_path__ + "static/media/g1.d7208983.jpg";